import { ReactNode } from "react";

import { Button, Colors, Intent } from "@blueprintjs/core";

import { Box, Flex } from "@/components/layout/flexbox";
import { LoadingOverlay } from "@/components/pieces/loading/LoadingOverlay";
import { StyledDialog } from "@/components/pieces/StyledDialog";

interface ConfirmmationProps {
  onYes: () => void;
  onNo: () => void;
  msg: ReactNode;
  loading?: boolean;
  primaryLabel?: ReactNode;
  cancelLabel?: ReactNode;
  intent?: Intent;
  style?: object;
}

export function ConfirmationInline({
  onYes,
  onNo,
  msg,
  loading,
  primaryLabel = "Remove",
  cancelLabel = "Cancel",
  intent = Intent.DANGER,
  style = {},
}: ConfirmmationProps) {
  return (
    <Flex
      justifyContent="center"
      alignItems="center"
      flexDirection="column"
      mt="12px"
      p={2}
      bg={Colors.WHITE}
      style={{
        borderRadius: "10px",
        border: `1px solid ${Colors.LIGHT_GRAY3}`,
        position: "relative",
        ...style,
      }}
    >
      <Box>{msg}</Box>
      <Flex mt={2} alignItems="center" justifyContent="space-around">
        <Button onClick={onYes} intent={intent}>
          {primaryLabel}
        </Button>
        <Button
          style={{
            marginLeft: "8px",
            border: 0,
            boxShadow: "none",
            color: Colors.GRAY3,
            backgroundColor: Colors.WHITE,
          }}
          onClick={onNo}
        >
          {cancelLabel}
        </Button>
      </Flex>
      {loading && <LoadingOverlay intent="primary" />}
    </Flex>
  );
}

interface ConfirmationWithDialogProps extends ConfirmmationProps {
  useDialog?: boolean;
  title?: ReactNode;
  open?: boolean;
}

export function Confirmation({
  onYes,
  onNo,
  msg,
  loading,
  primaryLabel = "Remove",
  cancelLabel = "Cancel",
  intent = Intent.DANGER,
  style = {},
  useDialog = false,
  open = false,
}: ConfirmationWithDialogProps) {
  const inlineComfirmation = (
    <ConfirmationInline
      onYes={onYes}
      onNo={onNo}
      msg={msg}
      loading={loading}
      primaryLabel={primaryLabel}
      cancelLabel={cancelLabel}
      intent={intent}
      style={useDialog ? { border: null, marginTop: 0, ...style } : style}
    />
  );
  if (!useDialog) {
    return <>{inlineComfirmation}</>;
  }

  return (
    <StyledDialog
      isOpen={open}
      lazy={true}
      title={null}
      width="480px"
      onClose={() => {
        onNo();
      }}
    >
      {inlineComfirmation}
    </StyledDialog>
  );
}
